import styled from "styled-components";
import NButton from "components/Nimbiv2/NButton";

const NButtonGoogleDesign = styled(NButton)`
  box-shadow: inset 0 0 0 1px #ccc;
  color: inherit;
  font-size: 0.875rem;
  font-weight: 700;
  &:hover {
    color: inherit !important;
    box-shadow: inset 0 0 0 1px #ccc !important;
  }
  &:active {
    color: inherit !important;
    box-shadow: inset 0 0 0 1px #ccc !important;
  }
  &:focus {
    color: inherit !important;
    box-shadow: inset 0 0 0 1px #ccc !important;
  }
`;
export default NButtonGoogleDesign;
